import axios from "axios";
import { SETTINGS } from "../../Settings";

export const MailLogRepository = {
  getAll: (page, size, orderBy, orderDirection) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/mail`,
      method: "GET",
      params: {
        page: page,
        size: size,
        sort: `${orderBy},${orderDirection}`,
      },
    });
  },

  requeue: (mailLogId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/mail/requeue/${mailLogId}`,
      method: "PUT",
    });
  },
};
